import { FC, ReactNode } from 'react';

import { Flex, FlexProps, theme, Typography } from 'antd';
import cn from 'classnames';

import styles from './OfferLine.module.scss';

interface IOfferLineProps extends Omit<FlexProps, 'children'> {
	label: ReactNode;
	value: ReactNode;
}

export const OfferLine: FC<IOfferLineProps> = ({ className, label, value, ...props }) => {
	const {
		token: { colorBorderSecondary },
	} = theme.useToken();

	return (
		<Flex
			justify="space-between"
			gap={16}
			{...props}
			className={cn(className, styles.offerLine)}
			style={{ borderColor: colorBorderSecondary }}>
			<Typography.Text type="secondary" ellipsis={{ tooltip: label }} style={{ maxWidth: value ? 300 : 400 }}>
				{label}
			</Typography.Text>
			<Typography.Text>{value}</Typography.Text>
		</Flex>
	);
};
